import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('usePartTypeLabels');

    return {
        BATTERY: t('battery'),
        FLOW_METER: t('flowMeter'),
        MOTOR: t('motor'),
        PROPELLER_SET: t('propellerSet'),
        PUMP: t('pump')
    };
};

export default useTranslation;
